import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Button from '../../button';
import Typography from '../../typography';

export const OtpBoxes = ({ onChange }) => {
  const [chars, setChars] = useState(Array(6).fill(''));
  const refs = useRef([]);

  const notify = (arr) => onChange(arr.join(''));

  const handleChange = (idx, val) => {
    const digit = val.replace(/\D/g, '').slice(-1);
    const next = [...chars];
    next[idx] = digit;
    setChars(next);
    notify(next);
    if (digit && idx < 5) refs.current[idx + 1]?.focus();
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === 'Backspace') {
      const next = [...chars];
      if (!chars[idx] && idx > 0) {
        next[idx - 1] = '';
        setChars(next);
        notify(next);
        refs.current[idx - 1]?.focus();
      } else if (chars[idx]) {
        next[idx] = '';
        setChars(next);
        notify(next);
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    const next = Array.from({ length: 6 }, (_, i) => pasted[i] || '');
    setChars(next);
    notify(next);
    refs.current[Math.min(pasted.length, 5)]?.focus();
  };

  return (
    <div className="otp-boxes">
      {chars.map((char, i) => (
        <input
          key={`opt-box-${i + 1}`}
          ref={(el) => { refs.current[i] = el; }}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={char}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
        />
      ))}
    </div>
  );
};

OtpBoxes.propTypes = {
  onChange: PropTypes.func.isRequired,
};

const StepTwo = ({
  onBack, onConfirm, loading, error,
}) => {
  const [token1, setToken1] = useState('');
  const [token2, setToken2] = useState('');

  const canConfirm = token1.length === 6 && token2.length === 6;

  return (
    <>
      <Typography type="superTitle-italic" text="Confirma la asociación" className="setup2fa__title" />
      <br />
      <Typography
        type="paragraph"
        text="Para vincular tu app necesitamos  dos códigos seguidos. Ingresa el código actual, espera a que cambie (cada 30s) e ingresa el siguiente."
      />
      <br />
      <div className="otp-group">
        <div className="otp-group__label">
          <span className="otp-number">1</span>
          <Typography text="Código actual de tu app" type="field-gray-light" />
        </div>
        <OtpBoxes onChange={setToken1} />
      </div>
      <div className="otp-group">
        <div className="otp-group__label">
          <span className="otp-number">2</span>
          <Typography text="Siguiente código (tras renovarse)" type="field-gray-light" />
        </div>
        <OtpBoxes onChange={setToken2} />
      </div>
      {error && <p className="step-two__error">{error}</p>}
      <div className="step-two__actions">
        <Button
          text="Atrás"
          type="tertiary"
          onClick={onBack}
          className="back-btn"
        />
        <Button
          text="Confirmar y activar"
          type="primary"
          onClick={() => onConfirm(token1, token2)}
          disabled={!canConfirm}
          loading={loading}
        />
      </div>
    </>
  );
};

StepTwo.propTypes = {
  onBack: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
};

StepTwo.defaultProps = {
  error: null,
};

export default StepTwo;
